/** Overlay "vire o dispositivo" — PORTRAIT é a orientação oficial do VOID HUNTER. */
import { i18n } from "../i18n/i18n";

export class OrientationOverlay {
  private readonly root: HTMLDivElement;
  private readonly text: HTMLElement;

  constructor(uiRoot: HTMLElement) {
    this.root = document.createElement("div");
    this.root.className = "orient-overlay";
    this.root.hidden = true;
    this.root.innerHTML = `<div class="orient-inner"><div class="orient-icon">📱↻</div><div class="orient-text"></div></div>`;
    uiRoot.appendChild(this.root);
    this.text = this.root.querySelector(".orient-text")!;
    i18n.onChange(() => this.render());
    this.render();
  }

  private render(): void {
    this.text.textContent = i18n.t("orientation.rotateDevice");
  }

  show(): void { this.root.hidden = false; }
  hide(): void { this.root.hidden = true; }
}
